import { ContractWidgetConfig } from '@models/contract-widgets';
import { ContractGeneralInformationWidgetComponent, PaymentMethodWidgetComponent } from '../customer-portal';
import { ReportedDamagesWidgetComponent } from 'app/customer-portal/widgets/reported-damages-widget/reported-damages-widget.component';

export const defaultContractWidgets: ContractWidgetConfig[] = [
    {
        component: ContractGeneralInformationWidgetComponent,
    },
    {
        component: PaymentMethodWidgetComponent,
    },
    {
        component: ReportedDamagesWidgetComponent,
    },
];
